import { StyleRules, Theme, makeStyles } from '@material-ui/core/styles';

import { Block } from '../types/_blocks.types';

export function makeBlockStyles<BlockProps extends Block>(
  styles: (theme: Theme) => StyleRules<string, BlockProps>,
): ReturnType<typeof makeStyles> {
  return makeStyles((theme) => ({
    boxBlock: ({ boxBlockProps }) => ({
      ...boxBlockProps,
    }),
    gridShow: ({ gridShow }) => ({ ...gridShow }),
    typography: ({ typography }) => ({ ...typography }),
    ...styles(theme),
  }));
}

export function useBlockStyles<BlockProps extends Block>(
  useStyles: ReturnType<typeof makeBlockStyles>,
  blockProps: BlockProps,
): ReturnType<ReturnType<typeof makeBlockStyles>> {
  const { show } = blockProps;

  const { backgroundImage, backgroundColor } = blockProps.background ?? {};
  const { paddingTop = '2rem', paddingBottom = '2rem' } =
    blockProps.padding ?? {};

  const gridShowProps =
    show &&
    (show.on === 'below'
      ? {
          [`@media screen and (min-width: ${show.size}px)`]: {
            display: 'none',
          },
        }
      : {
          [`@media screen and (max-width: ${show.size}px)`]: {
            display: 'none',
          },
        });

  const typographyProps = {
    [`@media screen and (max-width: 550px)`]: {
      fontSize: '2rem',
    },
  };

  const combinedStyles = {
    ...blockProps,
    boxBlockProps: {
      paddingTop,
      paddingBottom,
      ...(backgroundImage && { backgroundImage }),
      ...(backgroundColor && { backgroundColor }),
    },
    gridShow: { ...gridShowProps },
    typography: { ...typographyProps },
  } as BlockProps;
  return useStyles(combinedStyles);
}
